
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as QGxpdGVydGpzL2NvcmU from '@litertjs/core';
import * as d2FzbTpqcy1zdHJpbmc from './Cesure-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_QGxpdGVydGpzL2NvcmU_ = QGxpdGVydGpzL2NvcmU;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'kotlinx.io.node.existsSync_$external_fun' : (_this, p0) => _this.existsSync(p0),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt16Array' : (obj, index) => obj[index],
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.Float32Array_$external_fun' : (p0) => new Float32Array(p0),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.ArrayBuffer_$external_class_instanceof' : (x) => x instanceof ArrayBuffer,
    'org.khronos.webgl.ArrayBuffer_$external_class_get' : () => ArrayBuffer,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_2' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.length_$external_prop_getter_3' : (_this) => _this.length,
    'org.khronos.webgl.Int16Array_$external_class_instanceof' : (x) => x instanceof Int16Array,
    'org.khronos.webgl.Int16Array_$external_class_get' : () => Int16Array,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_3' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1, p2) => _this.removeEventListener(p0, p1, p2),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_2' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.document_$external_prop_getter' : (_this) => _this.document,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.assign_$external_fun' : (_this, p0) => _this.assign(p0),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.cookie_$external_prop_getter' : (_this) => _this.cookie,
    'org.w3c.dom.title_$external_prop_getter' : (_this) => _this.title,
    'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.sessionStorage_$external_prop_getter' : (_this) => _this.sessionStorage,
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.back_$external_fun' : (_this, ) => _this.back(),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.newValue_$external_prop_getter' : (_this) => _this.newValue,
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Storage_$external_class_instanceof' : (x) => x instanceof Storage,
    'org.w3c.dom.Storage_$external_class_get' : () => Storage,
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.URL_$external_fun' : (p0, p1, isDefault0) => new URL(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.url.searchParams_$external_prop_getter' : (_this) => _this.searchParams,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.dom.url.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.getMethodImplForFileList' : (obj, index) => obj[index],
    'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
    'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.ltei.shared.web.jsInt8FromMemory' : (memory, ptr, target, offset, count) => { target.set(new Int8Array(memory.buffer, ptr, count), offset); },
    'com.ltei.shared.web.jsFloat32FromMemory' : (memory, ptr, target, offset, count) => { target.set(new Float32Array(memory.buffer, ptr, count), offset); },
    'com.ltei.shared.web.jsInt8ToMemory' : (memory, ptr, source, offset, count) => { new Int8Array(memory.buffer, ptr, count).set(source.subarray(offset, offset + count)); },
    'com.ltei.shared.web.jsFloat32ToMemory' : (memory, ptr, source, offset, count) => { new Float32Array(memory.buffer, ptr, count).set(source.subarray(offset, offset + count)); },
    'com.cesure.score.format.newBytes' : (size) => new Uint8Array(size),
    'com.cesure.score.format.setByte' : (bytes, index, value) => bytes[index] = value,
    'com.cesure.score.format.decodeStrictly' : (label, bytes) => { try { return new TextDecoder(label, { fatal: true }).decode(bytes); } catch (e) { return null; } },
    'com.ltei.tflite.inputShape' : (model, i) => Array.from(model.getInputDetails()[i].shape),
    'com.ltei.tflite.runModel' : (model, tensors) => model.run(tensors),
    'com.ltei.tflite.tensorDelete' : (t) => t.delete(),
    'com.ltei.tflite.elementAt' : (arr, i) => arr[i],
    'com.ltei.tflite.lengthOf' : (arr) => arr.length,
    'com.ltei.tflite.deleteModel' : (model) => model.delete(),
    'com.ltei.tflite.createFloat32Array' : (size) => new Float32Array(size),
    'com.ltei.tflite.setFloat32Value' : (arr, val, i) => { arr[i] = val; },
    'com.ltei.tflite.newTensor' : (ctor, data, shape) => new ctor(data, shape),
    'com.ltei.tflite.createInt32Array' : (size) => new Int32Array(size),
    'com.ltei.tflite.setInt32Value' : (arr, val, i) => { arr[i] = val; },
    'com.ltei.tflite.createUint8Array' : (size) => new Uint8Array(size),
    'com.ltei.tflite.setUint8Value' : (arr, val, i) => { arr[i] = val; },
    'com.ltei.tflite.tensorData' : (t) => t.toTypedArray(),
    'com.ltei.tflite.dataValue' : (data, i) => data[i],
    'com.ltei.tflite.compileOptions' : (acc) => ({accelerator: acc}),
    'com.ltei.tflite.loadLiteRt_$external_fun' : (_this, p0) => _this.loadLiteRt(p0),
    'com.ltei.tflite.loadAndCompile_$external_fun' : (_this, p0, p1) => _this.loadAndCompile(p0, p1),
    'com.ltei.tflite.tensorConstructor_$external_prop_getter' : (_this) => _this.Tensor,
    'com.ltei.tflite.litert_$external_object_getInstance' : () => _ref_QGxpdGVydGpzL2NvcmU_,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'com.ltei.compose.platform.jsIsShareSupported' : () => !!window.navigator.share,
    'com.ltei.compose.platform.jsShareUrl' : (url) => window.navigator.share({ url: url }).then(() => 'shared', (e) => (e && e.name === 'AbortError') ? 'cancelled' : Promise.reject(e)),
    'com.ltei.compose.platform.jsEncodeURIComponent' : (s) => encodeURIComponent(s),
    'com.ltei.compose.platform.jsVibrateShort' : () => { if (typeof window.navigator.vibrate === 'function') window.navigator.vibrate(20); },
    'com.ltei.compose.platform.jsReloadPage' : () => window.location.reload(),
    'com.ltei.audio.capture.jsGetNativeSampleRate' : () => { const ctx = new AudioContext(); const sr = ctx.sampleRate; ctx.close(); return sr; },
    'com.ltei.audio.capture.jsStartAudioInput' : (sr, bs, onData, onError) => {
        let state = { stop: false, cleanup: null };
        (async () => {
            try {
                // Capture BRUTE : les trois traitements activés par défaut par le navigateur sont
                // calibrés pour la voix. Sur un instrument, le contrôle de gain pompe, la réduction de
                // bruit mange le sustain et l'annulation d'écho ducke le signal. Android capte en
                // AudioSource.MIC et iOS en catégorie Record, donc bruts eux aussi : sans ça, le web
                // était la seule plateforme à dégrader le son.
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: {
                        echoCancellation: false,
                        autoGainControl: false,
                        noiseSuppression: false,
                    },
                });

                // Si on a déjà demandé d'arrêter avant que le micro ne soit autorisé
                if (state.stop) {
                    stream.getTracks().forEach(t => t.stop());
                    return;
                }

                const ctx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: sr });
                const source = ctx.createMediaStreamSource(stream);
                const processor = ctx.createScriptProcessor(bs, 1, 1);
                processor.onaudioprocess = (e) => {
                    const inputData = e.inputBuffer.getChannelData(0);
                    const pcm = new Int16Array(inputData.length);
                    for (let i = 0; i < inputData.length; i++) {
                        let s = inputData[i];
                        if (s > 1) s = 1;
                        if (s < -1) s = -1;
                        pcm[i] = s * 0x7FFF;
                    }
                    onData(pcm);
                };
                // Le ScriptProcessorNode n'est tiré par le navigateur que s'il est connecté au graphe,
                // d'où cette sortie — mais le brancher SUR LES HAUT-PARLEURS renvoyait le micro dans la
                // pièce : le handler ne remplit jamais `outputBuffer`, et rien ne garantit qu'il soit
                // silencieux. Le micro se réentendait donc, se recaptait, et le doublon décalé finissait
                // dans le fichier. Ce retour ne passait par AUCUN volume de l'application (le gain du
                // lecteur est dans un autre graphe) : couper le son de l'app ne l'arrêtait pas.
                // Un puits à gain nul garde le nœud tiré sans rien laisser sortir.
                const sink = ctx.createGain();
                sink.gain.value = 0;
                source.connect(processor);
                processor.connect(sink);
                sink.connect(ctx.destination);

                state.cleanup = () => {
                    processor.disconnect();
                    sink.disconnect();
                    source.disconnect();
                    stream.getTracks().forEach(t => t.stop());
                    ctx.close();
                };
            } catch (e) {
                console.error('AudioInputManager error', e);
                onError(String(e));
            }
        })();
        return () => { 
            state.stop = true; 
            if (state.cleanup) state.cleanup(); 
        };
    },
    'com.ltei.audio.capture.jsStopAudioInput' : (cleanup) => { cleanup(); },
    'com.ltei.audio.playback.jsCreateAudioPlayerContext' : () => new (window.AudioContext || window.webkitAudioContext)(),
    'com.ltei.audio.playback.jsCreateGainNode' : (ctx, vol) => { const g = ctx.createGain(); g.gain.value = vol; g.connect(ctx.destination); return g; },
    'com.ltei.audio.playback.jsPlayBuffer' : (ctx, gainNode, buffer) => {
        try {
            if (ctx.state === 'suspended') ctx.resume();
            const source = ctx.createBufferSource();
            source.buffer = buffer;
            source.connect(gainNode);
            source.start();
        } catch (e) {
            console.error('AudioPlayer play error', e);
        }
    },
    'com.ltei.audio.playback.jsDecodeAudioData' : (ctx, bytes) => ctx.decodeAudioData(bytes.buffer),
    'com.ltei.audio.playback.jsPlayStoppable' : (ctx, gainNode, bytes, ramp) => {
        // Le handle porte tout ce qu'il faut pour reprendre : le tampon décodé, le décalage atteint et
        // l'instant où la source courante a démarré. Un `AudioBufferSourceNode` ne se met pas en pause
        // et ne se rejoue pas — il ne sert qu'une fois. Mettre en pause revient donc à l'arrêter en
        // notant où on en était, et reprendre à en créer un neuf démarré à ce décalage.
        const handle = { source: null, cancelled: false, buffer: null, offset: 0, startedAt: 0, playing: false, pending: false, over: false };
        // Each source plays through a fader of its own, which `ramp` (the shared web gain ramp) moves:
        // a take stopped, paused or moved fades out, and one taken up mid-way fades in.
        handle.begin = (from) => {
            if (!handle.buffer) return;
            const source = ctx.createBufferSource();
            source.buffer = handle.buffer;
            const fader = ctx.createGain();
            fader.gain.value = from > 0 ? 0 : 1;
            source.connect(fader);
            fader.connect(gainNode);
            if (from > 0) ramp(ctx, fader, 1);
            handle.fader = fader;
            source.onended = () => {
                if (handle.source !== source) return;
                // Played to its end: the player releases it, and its position is gone -- which tells the
                // caller "ended" apart from "barely started", as on Android and iOS.
                handle.source = null;
                handle.playing = false;
                handle.over = true;
            };
            source.start(0, Math.min(Math.max(from, 0), handle.buffer.duration));
            handle.source = source;
            handle.offset = from;
            handle.startedAt = ctx.currentTime;
            handle.playing = true;
        };
        handle.halt = () => {
            if (handle.source) {
                const source = handle.source, fader = handle.fader;
                const end = ramp(ctx, fader, 0);
                try { source.onended = null; source.stop(end); } catch (e) { /* already ended */ }
                setTimeout(() => { try { fader.disconnect(); } catch (e) {} }, Math.max(0, end - ctx.currentTime) * 1000 + 100);
                handle.source = null;
            }
            handle.playing = false;
        };
        handle.position = () => handle.playing ? handle.offset + (ctx.currentTime - handle.startedAt) : handle.offset;
        try {
            if (ctx.state === 'suspended') ctx.resume();
            const blob = new Blob([bytes], { type: 'audio/wav' });
            const url = URL.createObjectURL(blob);
            handle.pending = true;
            fetch(url)
                .then(res => res.arrayBuffer())
                .then(ab => ctx.decodeAudioData(ab))
                .then(buffer => {
                    URL.revokeObjectURL(url);
                    handle.pending = false;
                    if (handle.cancelled) return;
                    handle.buffer = buffer;
                    // Un déplacement ou une pause demandés pendant le décodage sont déjà notés dans
                    // `offset` / `startPaused` : on les respecte au lieu de repartir de zéro.
                    if (handle.startPaused) { handle.playing = false; return; }
                    handle.begin(handle.offset);
                })
                .catch(e => {
                    URL.revokeObjectURL(url);
                    handle.pending = false;
                    handle.over = true;
                    console.error('AudioPlayer decode error', e);
                });
        } catch (e) {
            handle.over = true;
            console.error('AudioPlayer play error', e);
        }
        return handle;
    },
    'com.ltei.audio.playback.jsStopHandle' : (handle) => {
        handle.cancelled = true;
        if (handle.halt) handle.halt();
        handle.offset = 0;
    },
    'com.ltei.audio.playback.jsSeekHandle' : (ctx, gainNode, handle, seconds) => {
        const wasPlaying = handle.playing;
        handle.halt();
        handle.offset = handle.buffer ? Math.min(seconds, handle.buffer.duration) : seconds;
        if (wasPlaying && handle.buffer) handle.begin(handle.offset);
    },
    'com.ltei.audio.playback.jsPauseHandle' : (ctx, handle) => {
        if (!handle.playing) { handle.startPaused = true; return; }
        const at = handle.position();
        handle.halt();
        handle.offset = at;
    },
    'com.ltei.audio.playback.jsHandleIsOver' : (handle) => handle.over === true,
    'com.ltei.audio.playback.jsResumeHandle' : (ctx, gainNode, handle) => {
        handle.startPaused = false;
        if (handle.playing) return;
        if (handle.buffer) handle.begin(handle.offset);
        if (ctx.state === 'suspended') ctx.resume();
    },
    'com.ltei.audio.playback.jsHandlePositionSec' : (ctx, handle) => handle.position ? handle.position() : 0,
    'com.ltei.audio.playback.jsHandleIsPlaying' : (handle) => !!handle.playing,
    'com.ltei.audio.playback.jsCloseAudioPlayerContextAfter' : (ctx, seconds) => { setTimeout(() => ctx.close(), seconds * 1000 + 50); },
    'com.ltei.audio.playback.jsUnlockAudioOnFirstGesture' : (ctx) => {
        const unlock = () => {
            if (ctx.state === 'suspended') ctx.resume();
            // Jouer un buffer d'un échantillon débloque réellement la sortie audio sur iOS,
            // là où un simple resume() ne suffit pas toujours.
            try {
                const b = ctx.createBuffer(1, 1, 22050);
                const src = ctx.createBufferSource();
                src.buffer = b;
                src.connect(ctx.destination);
                src.start(0);
            } catch (e) {}
            document.removeEventListener('touchend', unlock, true);
            document.removeEventListener('pointerdown', unlock, true);
            document.removeEventListener('click', unlock, true);
        };
        document.addEventListener('touchend', unlock, true);
        document.addEventListener('pointerdown', unlock, true);
        document.addEventListener('click', unlock, true);
    },
    'com.ltei.audio.playback.jsCreateAudioContext' : () => new (window.AudioContext || window.webkitAudioContext)(),
    'com.ltei.audio.playback.jsVoiceGain' : (entry) => entry.gain,
    'com.ltei.audio.playback.jsPlayCachedWave' : (ctx, buffer, vol, minRatio) => {
        const source = ctx.createBufferSource();
        source.buffer = buffer;
        const gain = ctx.createGain();
        gain.gain.value = vol;
        source.connect(gain);
        gain.connect(ctx.destination);
        // Deux chemins de libération, et le second n'est pas une ceinture de sécurité théorique :
        // sur iOS, un AudioContext interrompu (appel entrant, mise en arrière-plan) peut ne JAMAIS
        // émettre `onended`, et la source restait alors branchée au graphe pour toujours.
        let released = false;
        const release = () => {
            if (released) return;
            released = true;
            try { source.disconnect(); } catch (e) {}
            try { gain.disconnect(); } catch (e) {}
        };
        source.onended = release;
        // The timer outlasts the slowest reading: a voice slowed to the lowest pitch ratio rings its
        // buffer's length over that ratio, and must not be unplugged while it still sounds.
        setTimeout(release, (buffer.duration / minRatio + 0.5) * 1000);
        source.start();
        if (ctx.state === 'suspended') ctx.resume();
        return { source, gain, release };
    },
    'com.ltei.audio.playback.jsSetBufferPitchRatio' : (entry, ratio) => { entry.source.playbackRate.value = ratio; },
    'com.ltei.audio.playback.jsStopVoiceAt' : (ctx, entry, end) => {
        try { entry.source.stop(end); } catch (e) {}
        setTimeout(entry.release, Math.max(0, end - ctx.currentTime) * 1000 + 100);
    },
    'com.ltei.audio.playback.jsCreateWaveBuffer' : (ctx, samples, sr) => {
        const buffer = ctx.createBuffer(1, samples.length, sr);
        buffer.getChannelData(0).set(samples);
        return buffer;
    },
    'com.ltei.audio.playback.jsGainRampOf' : (seconds, leadQuanta, leadQuantaWithoutHold) => (ctx, node, target) => {
        const gain = node.gain;
        const hold = !!gain.cancelAndHoldAtTime;
        const at = ctx.currentTime + (hold ? leadQuanta : leadQuantaWithoutHold) * 128 / ctx.sampleRate;
        const last = node.lastRamp;
        const level = !last ? gain.value
            : at >= last.end ? last.target
            : last.level + (last.target - last.level) * Math.max(0, at - last.at) / (last.end - last.at);
        if (hold) {
            gain.cancelAndHoldAtTime(at);
            gain.setValueAtTime(level, at);
        } else {
            gain.cancelScheduledValues(at + 0.5 / ctx.sampleRate);
            if (last && last.at < at && at < last.end) gain.linearRampToValueAtTime(level, at);
            else gain.setValueAtTime(level, at);
        }
        gain.linearRampToValueAtTime(target, at + seconds);
        node.lastRamp = { at, level, end: at + seconds, target };
        return at + seconds;
    },
    'com.ltei.audio.playback.jsCallRamp' : (ramp, ctx, node, target) => ramp(ctx, node, target),
    'com.ltei.webrtc.jsCreatePeerConnection' : (configJson) => new RTCPeerConnection(JSON.parse(configJson)),
    'com.ltei.webrtc.jsOnIceCandidate' : (pc, cb) => { pc.onicecandidate = (e) => { if (e.candidate) cb(e.candidate.sdpMid, e.candidate.sdpMLineIndex, e.candidate.candidate); }; },
    'com.ltei.webrtc.__convertKotlinClosureToJsClosure_3' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2) => trampoline(f, p0, p1, p2)),
    'com.ltei.webrtc.jsOnConnectionStateChange' : (pc, cb) => { pc.onconnectionstatechange = () => cb(pc.connectionState); },
    'com.ltei.webrtc.jsOnTrack' : (pc, cb) => { pc.ontrack = (e) => { const audio = new Audio(); const stream = e.streams.length > 0 ? e.streams[0] : new MediaStream([e.track]); audio.srcObject = stream; audio.autoplay = true; cb(audio, stream); }; },
    'com.ltei.webrtc.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'com.ltei.webrtc.jsSetAudioElementEnabled' : (audio, enabled) => { audio.muted = !enabled; },
    'com.ltei.webrtc.jsSetAudioElementVolume' : (audio, volume) => { audio.volume = volume; },
    'com.ltei.webrtc.jsCreateOfferAndSetLocal' : (pc, onOk, onErr) => pc.createOffer().then(o => pc.setLocalDescription(o).then(() => onOk(o.sdp))).catch(e => onErr(String(e))),
    'com.ltei.webrtc.jsCreateAnswerAndSetLocal' : (pc, onOk, onErr) => pc.createAnswer().then(a => pc.setLocalDescription(a).then(() => onOk(a.sdp))).catch(e => onErr(String(e))),
    'com.ltei.webrtc.jsAddIceCandidate' : (pc, candidate, sdpMid, sdpMLineIndex) => pc.addIceCandidate({ candidate: candidate, sdpMid: sdpMid, sdpMLineIndex: sdpMLineIndex }),
    'com.ltei.webrtc.jsSetRemoteDescription' : (pc, type, sdp, onOk, onErr) => pc.setRemoteDescription({ type: type, sdp: sdp }).then(() => onOk()).catch(e => onErr(String(e))),
    'com.ltei.webrtc.jsAddMicTrack' : (pc, processing, onOk, onErr) => navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: processing, autoGainControl: processing } }).then(stream => { stream.getTracks().forEach(t => pc.addTrack(t, stream)); onOk(stream); }).catch(e => onErr(String(e))),
    'com.ltei.webrtc.jsSetStreamEnabled' : (stream, enabled) => stream.getAudioTracks().forEach(t => { t.enabled = enabled; }),
    'com.ltei.webrtc.jsGetRemoteAudioLevel' : (pc, cb) => pc.getStats().then(stats => { let level = 0; stats.forEach(s => { if (s.type === 'inbound-rtp' && s.kind === 'audio' && typeof s.audioLevel === 'number') { level = s.audioLevel; } }); cb(level); }).catch(() => cb(0)),
    'com.ltei.webrtc.jsStopStream' : (stream) => stream.getTracks().forEach(t => t.stop()),
    'com.ltei.webrtc.jsDetachAudioElement' : (audio) => { audio.pause(); if (audio.srcObject) { audio.srcObject.getTracks().forEach(t => t.stop()); } audio.srcObject = null; audio.remove(); },
    'com.ltei.webrtc.jsClosePeerConnection' : (pc) => pc.close(),
    'com.ltei.puny.jsBootstrap' : () => {
            if (window._puny) return;

            const ALLOWED_FIREBASE_HOSTS = [
                'www.gstatic.com',
                'www.googleapis.com',
                'cdn.firebase.com',
            ];

            function isAllowedFirebaseUrl(url) {
                try {
                    const parsed = new URL(url);
                    return parsed.protocol === 'https:' &&
                        ALLOWED_FIREBASE_HOSTS.some(h => parsed.hostname === h || parsed.hostname.endsWith('.' + h));
                } catch (_) {
                    return false;
                }
            }

            function isValidFirebaseModule(m) {
                return m && typeof m.getAnalytics === 'function' && typeof m.logEvent === 'function';
            }

            window._puny = {
                loader: null,

                ensure() {
                    if (this.loader) return this.loader;
                    this.loader = new Promise(resolve => {
                        // Preferred path when the host app loads Firebase through `import` (modular
                        // SDK): it already holds the instance and publishes a readiness promise.
                        // Without this we fell through to the DOM lookup below, which finds NOTHING —
                        // an imported module leaves no <script src> carrying the firebase-analytics
                        // URL, so every event was silently dropped.
                        const hostReady = window._punyFirebaseReady;
                        if (hostReady && typeof hostReady.then === 'function') {
                            return hostReady
                                .then(host => resolve(
                                    host && typeof host.logEvent === 'function' ? { type: 'host', host } : null
                                ))
                                .catch(e => {
                                    console.warn('[puny] Host Firebase init failed:', e);
                                    resolve(null);
                                });
                        }

                        if (typeof firebase !== 'undefined' && typeof firebase.analytics === 'function') {
                            try {
                                return resolve({ type: 'compat', instance: firebase.analytics() });
                            } catch (e) {
                                console.warn('[puny] Firebase compat init failed:', e);
                                return resolve(null);
                            }
                        }

                        const script = Array.from(document.querySelectorAll('script[src]'))
                            .find(s => s.src && s.src.includes('firebase-analytics'));
                        const url = script?.src ?? null;

                        if (url && isAllowedFirebaseUrl(url)) {
                            import(url)
                                .then(m => {
                                    if (isValidFirebaseModule(m)) {
                                        resolve({ type: 'modular', module: m });
                                    } else {
                                        console.warn('[puny] Loaded module does not look like Firebase Analytics, ignoring.');
                                        resolve(null);
                                    }
                                })
                                .catch(e => {
                                    console.warn('[puny] Failed to load Firebase Analytics module:', e);
                                    resolve(null);
                                });
                        } else {
                            if (url) console.warn('[puny] Firebase script URL is not in the allowlist, skipping:', url);
                            resolve(null);
                        }
                    });
                    return this.loader;
                },

                log(name, params) {
                    this.ensure().then(lib => {
                        if (!lib) return;
                        try {
                            if (lib.type === 'host') {
                                lib.host.logEvent(lib.host.analytics, name, params || {});
                            } else if (lib.type === 'compat') {
                                lib.instance.logEvent(name, params || {});
                            } else {
                                const analytics = lib.module.getAnalytics();
                                lib.module.logEvent(analytics, name, params || {});
                            }
                        } catch (e) {
                            console.warn('[puny] logEvent failed:', e);
                        }
                    });
                },

                userId(id) {
                    this.ensure().then(lib => {
                        try {
                            if (lib?.type === 'host' && typeof lib.host.setUserId === 'function') {
                                lib.host.setUserId(lib.host.analytics, id);
                            } else if (lib?.type === 'compat' && typeof lib.instance.setUserId === 'function') {
                                lib.instance.setUserId(id);
                            } else if (lib?.type === 'modular' && typeof lib.module.setUserId === 'function') {
                                lib.module.setUserId(lib.module.getAnalytics(), id);
                            }
                        } catch (e) { console.warn('[puny] setUserId failed:', e); }
                    });
                },

                consent(data) {
                    if (typeof gtag === 'function') {
                        try { gtag('consent', 'update', data); }
                        catch (e) { console.warn('[puny] gtag consent failed:', e); }
                    }
                    this.ensure().then(lib => {
                        try {
                            if (lib?.type === 'host' && typeof lib.host.setConsent === 'function') {
                                lib.host.setConsent(data);
                            } else if (lib?.type === 'modular' && typeof lib.module.setConsent === 'function') {
                                lib.module.setConsent(data);
                            }
                        } catch (e) { console.warn('[puny] setConsent failed:', e); }
                    });
                }
            };
        },
    'com.ltei.puny.createJsObject' : () => ({}),
    'com.ltei.puny.jsSetProperty' : (obj, key, value) => { obj[key] = value; },
    'com.ltei.puny.jsInternalSetConsent' : (data) => {
        if (!window._puny) { console.warn('[puny] Not initialized, dropping consent.'); return; }
        window._puny.consent(data);
    },
    'com.ltei.puny.jsInternalLogEvent' : (name, params) => {
        if (!window._puny) { console.warn('[puny] Not initialized, dropping event:', name); return; }
        window._puny.log(name, params);
    },
    'com.ltei.puny.jsInternalSetUserId' : (id) => {
        if (!window._puny) { console.warn('[puny] Not initialized, dropping user id.'); return; }
        window._puny.userId(id);
    },
    'com.ltei.audio.decode.decodeOrNullWhenRefused' : (ctx, buffer) => ctx.decodeAudioData(buffer).catch(e => { if (e && e.name === 'EncodingError') return null; throw e; }),
    'com.ltei.audio.decode.closeQuietly' : (ctx) => { ctx.close().catch(() => {}); },
    'com.ltei.audio.decode.AudioContext_$external_fun' : () => new AudioContext(),
    'com.ltei.audio.decode.sampleRate_$external_prop_getter' : (_this) => _this.sampleRate,
    'com.ltei.audio.decode.length_$external_prop_getter' : (_this) => _this.length,
    'com.ltei.audio.decode.numberOfChannels_$external_prop_getter' : (_this) => _this.numberOfChannels,
    'com.ltei.audio.decode.getChannelData_$external_fun' : (_this, p0) => _this.getChannelData(p0),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'dev.whyoleg.cryptography.random.getByte' : (obj, index) => obj[index],
    'dev.whyoleg.cryptography.random.getCrypto' : () => (globalThis ? globalThis.crypto : (window.crypto || window.msCrypto)),
    'dev.whyoleg.cryptography.random.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'dev.whyoleg.cryptography.random.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'dev.whyoleg.cryptography.random.length_$external_prop_getter' : (_this) => _this.length,
    'dev.whyoleg.cryptography.random.subarray_$external_fun' : (_this, p0, p1) => _this.subarray(p0, p1),
    'io.github.vinceglb.filekit.name_$external_prop_getter' : (_this) => _this.name,
    'io.github.vinceglb.filekit.webkitRelativePath_$external_prop_getter' : (_this) => _this.webkitRelativePath,
    'io.github.vinceglb.filekit.dialogs.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'io.github.vinceglb.filekit.dialogs.files_$external_prop_getter' : (_this) => _this.files,
    'io.github.vinceglb.filekit.dialogs.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'io.github.vinceglb.filekit.dialogs.webkitdirectory_$external_prop_setter' : (_this, v) => _this.webkitdirectory = v,
    'io.github.vinceglb.filekit.dialogs.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'io.github.vinceglb.filekit.dialogs.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'io.github.vinceglb.filekit.dialogs.oncancel_$external_prop_setter' : (_this, v) => _this.oncancel = v,
    'io.github.vinceglb.filekit.dialogs.click_$external_fun' : (_this, ) => _this.click(),
    'com.cesure.jsDownload' : (bytes, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(new File([bytes], name)); a.download = name; a.click(); },
    'com.cesure.jsSetupPopState' : (onPopState) => { window.addEventListener('popstate', function() { onPopState(window.location.pathname + window.location.search); }); },
    'com.cesure.jsPushUrl' : (p) => { history.pushState({ cesureStep: true }, '', p); },
    'com.cesure.jsReplaceUrl' : (p) => { history.replaceState({ cesureStep: true }, '', p); },
    'com.cesure.jsIsOwnHistoryEntry' : () => !!(history.state && history.state.cesureStep),
    'com.cesure.jsRegisterLaunchQueue' : (onHandle) => {
        if (!('launchQueue' in window) || !('files' in LaunchParams.prototype)) return;
        window.launchQueue.setConsumer((params) => {
            if (!params.files || params.files.length === 0) return;
            onHandle(params.files[0]);
        });
    },
    'com.cesure.jsReadLaunchedFile' : (handle, onFile, onFailure) => {
        (async () => {
            try {
                const file = await handle.getFile();
                onFile(file.name, await file.arrayBuffer());
            } catch (e) {
                onFailure(String(e));
            }
        })();
    },
    'com.cesure.pageIsProduction' : () => window._cesureProduction === true,
    'com.cesure.data.jsPut' : (key, data) => { const open = () => new Promise((ok, ko) => { const r = indexedDB.open('cesure-held-sounds', 1); r.onupgradeneeded = () => r.result.createObjectStore('sounds'); r.onsuccess = () => ok(r.result); r.onerror = () => ko(r.error); r.onblocked = () => ko('blocked'); }); return open().then(db => new Promise(ok => { const tx = db.transaction('sounds', 'readwrite'); tx.objectStore('sounds').put(data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength), key); tx.oncomplete = () => { db.close(); ok(true); }; tx.onerror = tx.onabort = () => { db.close(); ok(false); }; })).catch(() => false); },
    'com.cesure.data.jsGet' : (key) => { const open = () => new Promise((ok, ko) => { const r = indexedDB.open('cesure-held-sounds', 1); r.onupgradeneeded = () => r.result.createObjectStore('sounds'); r.onsuccess = () => ok(r.result); r.onerror = () => ko(r.error); r.onblocked = () => ko('blocked'); }); return open().then(db => new Promise(ok => { const g = db.transaction('sounds', 'readonly').objectStore('sounds').get(key); g.onsuccess = () => { db.close(); ok(g.result instanceof ArrayBuffer ? g.result : null); }; g.onerror = () => { db.close(); ok(null); }; })).catch(() => null); },
    'com.cesure.data.jsDelete' : (key) => { const open = () => new Promise((ok, ko) => { const r = indexedDB.open('cesure-held-sounds', 1); r.onupgradeneeded = () => r.result.createObjectStore('sounds'); r.onsuccess = () => ok(r.result); r.onerror = () => ko(r.error); r.onblocked = () => ko('blocked'); }); return open().then(db => new Promise(ok => { const tx = db.transaction('sounds', 'readwrite'); tx.objectStore('sounds').delete(key); tx.oncomplete = tx.onerror = tx.onabort = () => { db.close(); ok(null); }; })).catch(() => null); },
    'com.cesure.data.jsKeys' : () => { const open = () => new Promise((ok, ko) => { const r = indexedDB.open('cesure-held-sounds', 1); r.onupgradeneeded = () => r.result.createObjectStore('sounds'); r.onsuccess = () => ok(r.result); r.onerror = () => ko(r.error); r.onblocked = () => ko('blocked'); }); return open().then(db => new Promise(ok => { const g = db.transaction('sounds', 'readonly').objectStore('sounds').getAllKeys(); g.onsuccess = () => { db.close(); ok(g.result.map(String).join('\n')); }; g.onerror = () => { db.close(); ok(''); }; })).catch(() => ''); },
    'com.cesure.domain.midiinput.jsIsMidiSupported' : () => typeof navigator !== 'undefined' && typeof navigator.requestMIDIAccess === 'function',
    'com.cesure.domain.midiinput.jsProbeMidiIfGranted' : (onCount, onDeviceCountDelta, onNeedsRequest) => {
        function watch(access) {
            var count = 0;
            access.inputs.forEach(function() { count++; });
            access.onstatechange = function(e) {
                if (e.port.type === 'input') {
                    if (e.port.state === 'connected') { onDeviceCountDelta(1); }
                    else if (e.port.state === 'disconnected') { onDeviceCountDelta(-1); }
                }
            };
            onCount(count);
        }
        if (!navigator.permissions || !navigator.permissions.query) { onNeedsRequest(); return; }
        navigator.permissions.query({ name: 'midi', sysex: false }).then(function(status) {
            if (status.state !== 'granted') { onNeedsRequest(); return; }
            navigator.requestMIDIAccess()
                .then(watch)
                .catch(function() { onCount(0); });
        }).catch(function() { onNeedsRequest(); });
    },
    'com.cesure.domain.midiinput.jsRequestMidiAccess' : (onCount, onDeviceCountDelta, onDenied) => {
        if (typeof navigator === 'undefined' || typeof navigator.requestMIDIAccess !== 'function') {
            onDenied();
            return;
        }
        navigator.requestMIDIAccess().then(function(access) {
            var count = 0;
            access.inputs.forEach(function() { count++; });
            access.onstatechange = function(e) {
                if (e.port.type === 'input') {
                    if (e.port.state === 'connected') { onDeviceCountDelta(1); }
                    else if (e.port.state === 'disconnected') { onDeviceCountDelta(-1); }
                }
            };
            onCount(count);
        }).catch(function() { onDenied(); });
    },
    'com.cesure.domain.midiinput.jsListenMidiEvents' : (onEvent, onError) => {
        var h = { access: null, onState: null, inputs: [], released: false };
        navigator.requestMIDIAccess().then(function(access) {
            if (h.released) return;
            h.access = access;
            function setup(input) {
                h.inputs.push(input);
                input.onmidimessage = function(e) {
                    var d = e.data;
                    if (d.length >= 3) onEvent(d[0] & 0xF0, d[1] & 0x7F, d[2] & 0x7F);
                };
            }
            access.inputs.forEach(function(input) { setup(input); });
            // addEventListener, PAS `onstatechange = …` : si le navigateur partage l'instance
            // MIDIAccess, l'assignation écraserait le handler de comptage du probe (compte de
            // devices figé → collecte jamais coupée, bouton REC fantôme).
            h.onState = function(e) {
                if (e.port.type === 'input' && e.port.state === 'connected') { setup(e.port); }
            };
            access.addEventListener('statechange', h.onState);
        }).catch(function() { onError(); });
        return h;
    },
    'com.cesure.domain.midiinput.jsStopMidiEvents' : (h) => {
        h.released = true;
        if (h.access && h.onState) { h.access.removeEventListener('statechange', h.onState); }
        h.inputs.forEach(function(input) { input.onmidimessage = null; });
        h.onState = null;
        h.inputs = [];
        h.access = null;
    },
    'com.cesure.platform.jsOnAppHidden' : (onHidden) => {
            const hide = () => { if (document.visibilityState === 'hidden') onHidden(); };
            const leave = () => onHidden();
            document.addEventListener('visibilitychange', hide);
            window.addEventListener('pagehide', leave);
            return () => {
                document.removeEventListener('visibilitychange', hide);
                window.removeEventListener('pagehide', leave);
            };
        },
    'com.cesure.platform.jsCancel' : (cancel) => cancel(),
    'com.cesure.platform.jsIsDocumentVisible' : () => document.visibilityState === 'visible',
    'com.cesure.platform.jsSentrySetAppVersion' : (version) => {
        if (typeof Sentry === 'undefined') return;
        Sentry.setTag('app_version', version);
        Sentry.setTag('runtime', 'kotlin-wasm');
    },
    'com.cesure.platform.jsSentryBreadcrumb' : (step) => {
        if (typeof Sentry === 'undefined' || typeof Sentry.addBreadcrumb !== 'function') return;
        Sentry.addBreadcrumb({ category: 'boot', message: step, level: 'info' });
    },
    'com.cesure.platform.jsSentryCaptureException' : (type, message, stack) => {
        if (typeof Sentry === 'undefined' || typeof Sentry.getClient !== 'function' || !Sentry.getClient()) {
            return false;
        }
        // La stack Kotlin est portée par une vraie Error : Sentry groupe sur (name, message, frames).
        const error = new Error(message);
        error.name = type;
        if (stack) error.stack = type + ': ' + message + '\n' + stack;
        Sentry.captureException(error, { tags: { source: 'kotlin' } });
        return true;
    },
    'com.cesure.platform.jsFetchDeployedRelease' : (t) => fetch('/version.json?t=' + t, { cache: 'no-store' })
            .then(r => r.ok ? r.json() : null)
            .then(j => (j && typeof j.release === 'string') ? j.release : null)
            .catch(() => null),
    'com.cesure.platform.jsNewParts' : () => [],
    'com.cesure.platform.jsPushPart' : (parts, part) => { parts.push(part); },
    'com.cesure.platform.jsDownloadParts' : (parts, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(new File(parts, name)); a.download = name; a.click(); },
    'com.cesure.platform.jsWatchGraphics' : () => {
        if (globalThis.__cesureGraphicsWatched) return;
        const native = HTMLCanvasElement.prototype.getContext;
        globalThis.__cesureGraphicsWatched = native;
        const tell = (what) => {
            try {
                const page = globalThis._cesureGraphics;
                if (page && typeof page[what] === 'function') page[what]();
            } catch (e) { console.warn('[graphics] the page hook threw:', e); }
        };
        HTMLCanvasElement.prototype.getContext = function (kind) {
            const gl = native.apply(this, arguments);
            if (kind !== 'webgl2') return gl;
            const webgl1 = gl && typeof WebGLRenderingContext === 'function' && gl instanceof WebGLRenderingContext;
            if (!gl || webgl1 || gl.isContextLost()) { tell('failed'); return gl; }
            let failed = false;
            let ready = false;
            const fail = () => { if (!failed) { failed = true; tell('failed'); } };
            this.addEventListener('webglcontextlost', fail);
            const createProgram = gl.createProgram;
            gl.createProgram = function () {
                const program = createProgram.apply(gl, arguments);
                if (program === null || gl.isContextLost()) fail();
                else if (!ready && !failed) { ready = true; tell('ready'); }
                return program;
            };
            return gl;
        };
    },
    'com.cesure.platform.jsEnterFullscreen' : (onExit) => { try { const h = { onChange: null }; h.onChange = () => { if (!document.fullscreenElement) onExit(); }; document.addEventListener('fullscreenchange', h.onChange); const el = document.documentElement; if (el.requestFullscreen) { el.requestFullscreen().catch(() => {}); } return h; } catch (e) { return null; } },
    'com.cesure.platform.jsLeaveFullscreen' : (h) => { try { if (h.onChange) { document.removeEventListener('fullscreenchange', h.onChange); h.onChange = null; } if (document.fullscreenElement && document.exitFullscreen) { document.exitFullscreen().catch(() => {}); } } catch (e) {} },
    'com.cesure.platform.jsRequestWakeLock' : () => { try { if (!navigator.wakeLock) return null; const h = { sentinel: null, released: false, onVis: null }; const acquire = () => { if (h.released || h.sentinel || document.visibilityState !== 'visible') return; navigator.wakeLock.request('screen').then((s) => { if (h.released) { s.release(); return; } h.sentinel = s; s.addEventListener('release', () => { h.sentinel = null; }); }).catch(() => {}); }; h.onVis = () => { acquire(); }; document.addEventListener('visibilitychange', h.onVis); acquire(); return h; } catch (e) { return null; } },
    'com.cesure.platform.jsReleaseWakeLock' : (h) => { try { h.released = true; if (h.onVis) { document.removeEventListener('visibilitychange', h.onVis); h.onVis = null; } if (h.sentinel) { h.sentinel.release(); h.sentinel = null; } } catch (e) {} },
    'com.cesure.platform.jsEnsureMicPermission' : (onDone) => { if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { onDone(false); return; } const ask = () => navigator.mediaDevices.getUserMedia({ audio: true }).then(s => { s.getTracks().forEach(t => t.stop()); onDone(true); }).catch(() => onDone(false)); if (!navigator.permissions || !navigator.permissions.query) { ask(); return; } navigator.permissions.query({ name: 'microphone' }).then(st => { if (st.state === 'granted') onDone(true); else if (st.state === 'denied') onDone(false); else ask(); }).catch(() => ask()); },
    'com.cesure.platform.jsReencodeAsJpeg' : (data, quality) => createImageBitmap(new Blob([data])).then(bitmap => {
            const width = bitmap.width, height = bitmap.height;
            const canvas = typeof OffscreenCanvas !== 'undefined'
                ? new OffscreenCanvas(width, height)
                : Object.assign(document.createElement('canvas'), { width, height });
            const context = canvas.getContext('2d');
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, width, height);
            context.drawImage(bitmap, 0, 0);
            bitmap.close();
            return canvas.convertToBlob
                ? canvas.convertToBlob({ type: 'image/jpeg', quality })
                : new Promise(done => canvas.toBlob(done, 'image/jpeg', quality));
        }).then(blob => blob ? blob.arrayBuffer() : null).catch(() => null),
    'com.cesure.platform.jsWatchFileDialogs' : (onOpened, onBlurred, onReturned) => { const click = HTMLInputElement.prototype.click; HTMLInputElement.prototype.click = function () { if (this.type === 'file') onOpened(); return click.call(this); }; window.addEventListener('blur', () => onBlurred()); window.addEventListener('focus', () => onReturned()); },
    'com.cesure.platform.jsRecorderSupported' : () => !!(window.MediaRecorder && window.AudioContext),
    'com.cesure.platform.jsRecorderCreate' : () => { const ctx = new AudioContext(); const dest = ctx.createMediaStreamDestination(); const proc = ctx.createScriptProcessor(2048, 1, 1); const sink = ctx.createGain(); sink.gain.value = 0; proc.connect(sink); sink.connect(ctx.destination); const h = { ctx: ctx, dest: dest, proc: proc, sources: [], chunks: [], env: [], mime: '', rec: null, blob: null, audio: null, solo: null, tracks: {} }; proc.onaudioprocess = (e) => { const d = e.inputBuffer.getChannelData(0); let s = 0; for (let i = 0; i < d.length; i++) s += d[i] * d[i]; h.env.push(Math.sqrt(s / d.length)); }; return h; },
    'com.cesure.platform.jsRecorderStart' : (h) => { const mimes = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4']; let mime = ''; for (const m of mimes) { if (MediaRecorder.isTypeSupported(m)) { mime = m; break; } } if (!mime) return false; h.mime = mime; const rec = new MediaRecorder(h.dest.stream, { mimeType: mime, audioBitsPerSecond: 128000 }); rec.ondataavailable = (e) => { if (e.data && e.data.size > 0) h.chunks.push(e.data); }; h.rec = rec; rec.start(10000); return true; },
    'com.cesure.platform.jsRecorderEnsureTrack' : (h, id) => { if (h.tracks[id]) return true; if (!h.mime) return false; const dest = h.ctx.createMediaStreamDestination(); const t = { dest: dest, chunks: [], rec: null }; const rec = new MediaRecorder(dest.stream, { mimeType: h.mime, audioBitsPerSecond: 128000 }); rec.ondataavailable = (e) => { if (e.data && e.data.size > 0) t.chunks.push(e.data); }; t.rec = rec; rec.start(10000); h.tracks[id] = t; return true; },
    'com.cesure.platform.jsRecorderAddStream' : (h, id, stream) => { const src = h.ctx.createMediaStreamSource(stream); src.connect(h.dest); src.connect(h.proc); const t = h.tracks[id]; if (t) src.connect(t.dest); h.sources.push(src); },
    'com.cesure.platform.jsRecorderOpenMic' : (h, onDone) => { navigator.mediaDevices.getUserMedia({ audio: true }).then(s => { h.solo = s; onDone(); }).catch(() => onDone()); },
    'com.cesure.platform.jsRecorderHasMic' : (h) => !!h.solo,
    'com.cesure.platform.jsRecorderAddSolo' : (h, id) => { if (!h.solo) return; const src = h.ctx.createMediaStreamSource(h.solo); src.connect(h.dest); src.connect(h.proc); const t = h.tracks[id]; if (t) src.connect(t.dest); h.sources.push(src); },
    'com.cesure.platform.jsRecorderCloseMic' : (h) => { if (!h.solo) return; try { h.solo.getTracks().forEach(t => t.stop()); } catch (e) {} h.solo = null; },
    'com.cesure.platform.jsRecorderClearSources' : (h) => { h.sources.forEach(s => { try { s.disconnect(); } catch (e) {} }); h.sources = []; },
    'com.cesure.platform.jsRecorderStop' : (h, onDone) => { const recs = [h.rec].concat(Object.values(h.tracks).map(t => t.rec)) .filter(r => r && r.state !== 'inactive'); if (recs.length === 0) { onDone(); return; } let left = recs.length; recs.forEach(r => { r.onstop = () => { if (--left === 0) onDone(); }; try { r.requestData(); } catch (e) {} r.stop(); }); },
    'com.cesure.platform.jsRecorderEnvelopeSize' : (h) => h.env.length,
    'com.cesure.platform.jsRecorderEnvelopeAt' : (h, i) => h.env[i],
    'com.cesure.platform.jsRecorderEnvelopeRateHz' : (h) => h.ctx.sampleRate / 2048.0,
    'com.cesure.platform.jsRecorderTrackBytes' : (h, id, onDone) => { const t = h.tracks[id]; if (!t || t.chunks.length === 0) { onDone(new ArrayBuffer(0)); return; } new Blob(t.chunks, { type: h.mime }).arrayBuffer().then(onDone); },
    'com.cesure.platform.jsRecorderPlayRange' : (h, start, end, startTimeoutMs, onEnded, onFailed) => { if (!h.blob) h.blob = new Blob(h.chunks, { type: h.mime }); if (!h.audio) { h.audio = new Audio(); h.audio.src = URL.createObjectURL(h.blob); } const a = h.audio; const token = (h.playToken = (h.playToken || 0) + 1); const clear = () => { a.ontimeupdate = null; a.onended = null; a.onerror = null; a.onplaying = null; a.onloadedmetadata = null; a.ondurationchange = null; if (h.playTimer) { clearTimeout(h.playTimer); h.playTimer = null; } }; const finish = (ok) => { if (h.playToken !== token) return; clear(); h.playToken++; if (ok) { onEnded(); } else { onFailed(); } }; const seekAndPlay = () => { a.currentTime = start; a.ontimeupdate = () => { if (a.currentTime >= end) { a.pause(); finish(true); } }; a.onended = () => finish(true); const p = a.play(); if (p && p.catch) p.catch(() => finish(false)); }; a.onerror = () => finish(false); a.onplaying = () => { if (h.playTimer) { clearTimeout(h.playTimer); h.playTimer = null; } }; h.playTimer = setTimeout(() => finish(false), startTimeoutMs); if (isFinite(a.duration) && a.duration > 0) { seekAndPlay(); } else { const onMeta = () => { if (isFinite(a.duration) && a.duration > 0) { seekAndPlay(); } else { a.ondurationchange = () => { if (isFinite(a.duration)) { a.ondurationchange = null; seekAndPlay(); } }; a.currentTime = 1e7; } }; if (a.readyState >= 1) { onMeta(); } else { a.onloadedmetadata = onMeta; } } },
    'com.cesure.platform.jsRecorderStopPlayback' : (h) => { h.playToken = (h.playToken || 0) + 1; if (h.playTimer) { clearTimeout(h.playTimer); h.playTimer = null; } if (h.audio) { const a = h.audio; a.pause(); a.ontimeupdate = null; a.onended = null; a.onerror = null; a.onplaying = null; a.onloadedmetadata = null; a.ondurationchange = null; } },
    'com.cesure.platform.jsRecorderExportRangeWav' : (h, start, end, name, onDone) => { if (!h.blob) h.blob = new Blob(h.chunks, { type: h.mime }); h.blob.arrayBuffer().then(buf => h.ctx.decodeAudioData(buf)).then(ab => { const sr = ab.sampleRate; const s = Math.max(0, Math.floor(start * sr)); const e = Math.min(ab.length, Math.floor(end * sr)); const n = Math.max(0, e - s); const ch = ab.numberOfChannels; const mono = new Float32Array(n); for (let c = 0; c < ch; c++) { const d = ab.getChannelData(c); for (let i = 0; i < n; i++) mono[i] += d[s + i] / ch; } const wav = new ArrayBuffer(44 + n * 2); const v = new DataView(wav); const ws = (o, str) => { for (let i = 0; i < str.length; i++) v.setUint8(o + i, str.charCodeAt(i)); }; ws(0, 'RIFF'); v.setUint32(4, 36 + n * 2, true); ws(8, 'WAVE'); ws(12, 'fmt '); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true); v.setUint32(24, sr, true); v.setUint32(28, sr * 2, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true); ws(36, 'data'); v.setUint32(40, n * 2, true); for (let i = 0; i < n; i++) { const x = Math.max(-1, Math.min(1, mono[i])); v.setInt16(44 + i * 2, x < 0 ? x * 32768 : x * 32767, true); } const a = document.createElement('a'); a.href = URL.createObjectURL(new Blob([wav], { type: 'audio/wav' })); a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 10000); onDone(true); }).catch(() => onDone(false)); },
    'com.cesure.platform.jsRecorderDownloadFull' : (h, name) => { if (!h.blob) h.blob = new Blob(h.chunks, { type: h.mime }); if (h.blob.size === 0) return false; const a = document.createElement('a'); a.href = URL.createObjectURL(h.blob); a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 10000); return true; },
    'com.cesure.platform.jsRecorderFullExtension' : (h) => h.mime.indexOf('mp4') >= 0 ? 'm4a' : 'webm',
    'com.cesure.platform.jsRecorderDispose' : (h) => { try { if (h.audio) { h.audio.pause(); h.audio.src = ''; } } catch (e) {} try { h.proc.disconnect(); } catch (e) {} try { h.ctx.close(); } catch (e) {} try { if (h.solo) h.solo.getTracks().forEach(t => t.stop()); } catch (e) {} h.solo = null; Object.values(h.tracks).forEach(t => { try { if (t.rec && t.rec.state !== 'inactive') t.rec.stop(); } catch (e) {} }); h.tracks = {}; h.chunks = []; h.env = []; h.blob = null; h.audio = null; },
    'com.cesure.platform.jsClaimLock' : (name, onDone) => { let done = false; const finish = (v) => { if (!done) { done = true; onDone(v); } }; try { const held = (globalThis.__cesureDraftLocks = globalThis.__cesureDraftLocks || new Map()); if (held.has(name)) { finish(1); return; } if (!navigator.locks || !navigator.locks.request) { finish(-1); return; } navigator.locks.request(name, { ifAvailable: true }, (lock) => { if (!lock) { finish(0); return undefined; } return new Promise((release) => { held.set(name, release); finish(1); }); }).catch(() => { held.delete(name); finish(-1); }); } catch (e) { finish(-1); } },
    'com.cesure.platform.jsReleaseLock' : (name) => { try { const held = globalThis.__cesureDraftLocks; if (!held) return; const release = held.get(name); held.delete(name); if (release) release(); } catch (e) {} },
    'com.cesure.ui.component.piano.jsPianoProbe' : (v, p) => {
        const w = window;
        if (!w.__pianoProbeOn) return;
        if (!w.__pianoProbe) w.__pianoProbe = [];
        if (w.__pianoProbe.length < 20000) w.__pianoProbe.push([performance.now(), v, p]);
    },
    'com.cesure.ui.composable.jsArrayBuffer' : (file) => file.arrayBuffer(),
    'com.cesure.ui.composable.droppedArrayBuffer' : (file) => file.arrayBuffer(),
    'com.cesure.ui.composable.jsHasFiles' : (data) => !!data && Array.from(data.types).includes('Files'),
    'com.cesure.ui.composable.jsFileSize' : (file) => file.size,
    'com.cesure.ui.composable.browserEventListener' : (callback) => ({ handleEvent: callback }),
    'com.cesure.ui.input.isPointerCancel' : (event) => !!(event && event.type === 'pointercancel'),
    'com.cesure.ui.input.isShiftKey' : (event) => !!(event && event.shiftKey === true),
    'com.cesure.ui.input.deltaModeToPixels' : (event) => {
            switch (event && event.deltaMode) {
              case 1: return 40;   // DOM_DELTA_LINE — Firefox Windows/Linux : 3 lignes par cran
              case 2: return 800;  // DOM_DELTA_PAGE — rarissime, ordre de grandeur d'un écran
              default: return 1;   // DOM_DELTA_PIXEL — Chrome, Safari, Edge, et tout le mobile
            }
        }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    